import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  Tabs,
  Tab,
} from "@mui/material";
import { Notifications, CalendarToday } from "@mui/icons-material";
import Coupon from "./Coupon";
import AddBanner from "./AddBanner";
// import AddVbanners from "./AddVbanner";
// import VendorNotification from "./VendorNotification";
import { VendorappBar } from "../../../components";
import { useSelector } from "react-redux";

// TabPanel component (unchanged)
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export default function MarkertandPromotions({ onBackScreenName }) {
  const [value, setValue] = useState(0);
  const userDetails = useSelector((state) => state.user.userdetails);
  const userVtype = userDetails?.vtype;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  useEffect(() => {
    if (userVtype === 'vlistuser' && value === 0) {
      setValue(1);
    }
  }, [userVtype, value]);

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <VendorappBar
          title={"Marketing and Promotions"}
          onBackScreenName={handleScreeName}
        />

        {/* Tabs */}
        <Tabs value={value} onChange={handleChange} aria-label="settings tabs">
          {userVtype !== 'vlistuser' && (
            <Tab label="Add Banner" sx={{ textTransform: "none" }} />
          )}
          <Tab label="Coupons" sx={{ textTransform: "none" }} />
        </Tabs>

        {/* Tab Panels */}
        <TabPanel value={value} index={0}>
          {userVtype !== 'vlistuser' && <AddBanner />}
        </TabPanel>

        {/* <TabPanel value={value} index={1}>
          <AddVbanners />
        </TabPanel> */}

        <TabPanel value={value} index={1}>
          <Coupon />
        </TabPanel>

        {/* <TabPanel value={value} index={2}>
          <VendorNotification />
        </TabPanel> */}
      </Box>
    </Box>
  );
}
